import { subMonths } from 'date-fns';

// Lower bound for the rule/override rows the bootstrap fetches — without it the selection grows for
// the life of the client, since every scheduling toggle adds an override row.
//
// Shared, not recomputed per call site: it is part of the Apollo cache key for CLIENT_BY_ID, so two
// callers passing different instants would read and write different cache entries.
export const RESOURCE_SCHEDULE_CUTOFF = subMonths(new Date(), 1).toISOString();
